import { render, staticRenderFns } from "./LangSwitch.vue?vue&type=template&id=25c1a7cb&scoped=true&"
import script from "./LangSwitch.vue?vue&type=script&lang=ts&"
export * from "./LangSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./LangSwitch.vue?vue&type=style&index=0&id=25c1a7cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c1a7cb",
  null
  
)

export default component.exports